import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AuthService } from '@services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class MessageLogFrontService {
    private url = environment.urlBackend + '/message-log';
    private usersUrl = environment.urlBackend + '/users';

    constructor(
        private http: HttpClient,
        private auth: AuthService,
    ) {}

    private async getAuthHeaders() {
        const jwt = await this.auth.loadJwToken();
        return new HttpHeaders({
            'x-token': jwt || '',
        });
    }

    async getDevicesSummary() {
        const headers = await this.getAuthHeaders();

        console.log('📡 [HTTP] GET /users/pushDevicesSummary');

        const response = await this.http
            .get<any>(`${this.usersUrl}/pushDevicesSummary`, { headers })
            .toPromise();

        console.log('📡 [HTTP RESPONSE devices]', response);

        return response;
    }

    async getSummary() {
        const headers = await this.getAuthHeaders();
        return this.http
            .get<any[]>(`${this.url}/summary`, { headers })
            .toPromise();
    }

    async getByPlan(planId: string) {
        const headers = await this.getAuthHeaders();
        return this.http
            .get<any[]>(`${this.url}/by-plan/${planId}`, { headers })
            .toPromise();
    }

    async getByUser(userId: string) {
        const headers = await this.getAuthHeaders();
        return this.http
            .get<any[]>(`${this.url}/by-user/${userId}`, { headers })
            .toPromise();
    }

    async search(params: any) {
        const headers = await this.getAuthHeaders();
        return this.http
            .get<any[]>(`${this.url}/search`, { params, headers })
            .toPromise();
    }

    async getDailyStats(month: string) {
        const headers = await this.getAuthHeaders();
        return this.http
            .get<any[]>(`${this.url}/stats/daily`, {
                params: { month },
                headers,
            })
            .toPromise();
    }

    async getPushSummary(desde?: string, hasta?: string) {
        const headers = await this.getAuthHeaders();
        let params = new HttpParams();
        if (desde) params = params.set('desde', desde);
        if (hasta) params = params.set('hasta', hasta);

        return this.http
            .get<any>(`${this.url}/push/summary`, { params, headers })
            .toPromise();
    }

    async searchUsers(q: string, limit = 10, desde?: string, hasta?: string) {
        const headers = await this.getAuthHeaders();
        let params = new HttpParams()
            .set('q', q || '')
            .set('limit', String(limit));

        if (desde) params = params.set('desde', desde);
        if (hasta) params = params.set('hasta', hasta);

        return this.http
            .get<any[]>(`${this.url}/push/users`, { params, headers })
            .toPromise();
    }

    async getPushByUser(userId: string, desde?: string, hasta?: string) {
        const headers = await this.getAuthHeaders();
        let params = new HttpParams();
        if (desde) params = params.set('desde', desde);
        if (hasta) params = params.set('hasta', hasta);

        return this.http
            .get<any[]>(`${this.url}/push/by-user/${userId}`, {
                params,
                headers,
            })
            .toPromise();
    }

    async getDailyRange(
        desde: string,
        hasta: string,
    ): Promise<{ response: any[] }> {
        const headers = await this.getAuthHeaders();
        const params = new HttpParams().set('desde', desde).set('hasta', hasta);

        return this.http
            .get<{
                response: any[];
            }>(`${this.url}/push/stats/daily-range`, { params, headers })
            .toPromise();
    }

    async getDevicesList() {
        const headers = await this.getAuthHeaders();

        return this.http
            .get<{
                ok: boolean;
                response: any[];
            }>(`${this.usersUrl}/pushDevicesList`, { headers })
            .toPromise();
    }
}
